import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { BrandViewModelMultiSelector, VehicleTypeMultiSelector } from '../business-entities/brand-view-model-multiselector';
import { DealerRequestModel } from '../business-entities/dealer-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { EditMechanicList, MechanicUserList } from '../business-entities/mechanicList-model';
import { UserRecipientViewModel } from '../business-entities/user-recipient-list-view.model';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { MechanicEfficiencyReportRequestModel, MechanicEfficiencyReportResponseModel } from '../business-entities/mechanic-efficiency-report-model';
import { MechanicAccuracyReportRequestModel, MechanicAccuracyResponseModel } from '../business-entities/mechanic-accuracy-report-model';
import {  MechanicTimeStampReportModel,  TimeStampResponseModel } from '../business-entities/time-stamp-report-model';
import { TotalSoldHoursReportResponseModel } from '../business-entities/total-sold-hours-report-model';
import {
    MechanicCustomerWaitingOccasionDeleteModel, MechanicCustomerWaitingOccasionSaveModel, MechanicCustomerWaitingOccasionViewModel,
    MechanicCustomerWaitingResultModel, MechanicCustomerWaitingSlotSaveModel, MechanicCustomerWaitingSlotViewModel
} from '../business-entities/mechanic-customer-waiting-hours-view-model';

@Injectable({
    providedIn: 'root'
})

export class MechanicDataService {
    constructor(private dataProvider: DataService) {
    }

    GetMechanicList(id: string, status: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicList, id, status).toPromise();
    }

    async getCompetence(status: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCompetence, status).toPromise();
    }

    GetDealerList(dealerRequestModel: DealerRequestModel): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetDealerList, dealerRequestModel).toPromise();
    }

    GetMechanicLeavesList(id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicLeavesList, id).toPromise();
    }

    AddMechanic(mechanicInfo: MechanicUserList): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddMechanic, mechanicInfo).toPromise();
    }
    
    ValidateDmsMechanicId(id: any, dmsMechanicId: any): Promise<boolean>
    {
        return this.dataProvider.Get<boolean>(Urls.ValidateDmsMechanicId, id, dmsMechanicId).toPromise();
    }

    AddMechanicLeaves(mechanicLeaves: any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddMechanicLeaves, mechanicLeaves).toPromise();
    }

    GetMechanicById(Id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicById, Id).toPromise();
    }

    GetMechanicLeavebyId(Id: number,MechanicLeaveRecurringId:number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicLeavebyId, Id,(MechanicLeaveRecurringId)?MechanicLeaveRecurringId:0).toPromise();
    }

    GetMechanicOpeningHoursById(Id: number, OccasionId: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicOpeningHoursById, Id, OccasionId).toPromise();
    }

    GetDealerMechanicLunchShiftDetails(Id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerMechanicLunchShiftDetails, Id).toPromise();
    }

    UpdateMechanic(mechanicInfo: EditMechanicList): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateMechanic, mechanicInfo).toPromise();
    }

    UpdateMechanicOpeningHours(shiftTime: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateMechanicOpeningHours, shiftTime).toPromise();
    }

    GetMechanicCustomerWaitingOccasions(dealerId: string): Promise<GenericResponse<MechanicCustomerWaitingOccasionViewModel[]>> {
        return this.dataProvider.Get<GenericResponse<MechanicCustomerWaitingOccasionViewModel[]>>(Urls.GetMechanicCustomerWaitingOccasions, dealerId).toPromise();
    }

    AddUpdateMechanicCustomerWaitingOccasion(model: MechanicCustomerWaitingOccasionSaveModel): Promise<GenericResponse<MechanicCustomerWaitingResultModel>> {
        return this.dataProvider.Post<GenericResponse<MechanicCustomerWaitingResultModel>>(Urls.AddUpdateMechanicCustomerWaitingOccasion, model).toPromise();
    }

    DeleteMechanicCustomerWaitingOccasion(model: MechanicCustomerWaitingOccasionDeleteModel): Promise<GenericResponse<MechanicCustomerWaitingResultModel>> {
        return this.dataProvider.Post<GenericResponse<MechanicCustomerWaitingResultModel>>(Urls.DeleteMechanicCustomerWaitingOccasion, model).toPromise();
    }

    GetMechanicCustomerWaitingSlots(mechanicId: number, occasionId: number): Promise<GenericResponse<MechanicCustomerWaitingSlotViewModel[]>> {
        return this.dataProvider.Get<GenericResponse<MechanicCustomerWaitingSlotViewModel[]>>(Urls.GetMechanicCustomerWaitingSlots, mechanicId, occasionId).toPromise();
    }

    SaveMechanicCustomerWaitingSlots(model: MechanicCustomerWaitingSlotSaveModel): Promise<GenericResponse<MechanicCustomerWaitingResultModel>> {
        return this.dataProvider.Put<GenericResponse<MechanicCustomerWaitingResultModel>>(Urls.SaveMechanicCustomerWaitingSlots, model).toPromise();
    }

    UpdateMechanicLeaves(mechanicLeaves: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateMechanicLeaves, mechanicLeaves).toPromise();
    }

    DeleteLeave(leaveId: number): Promise<any> {
        return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteLeave, leaveId).toPromise();
    }

    getRecipientList(mechanicId: number): Promise<GenericResponse<Array<UserRecipientViewModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<UserRecipientViewModel>>>(Urls.GetList, mechanicId).toPromise();
    }

    getVehicleTypes() {
        return this.dataProvider.Get<GenericResponse<Array<VehicleTypeMultiSelector>>>(Urls.GetVehicleType).toPromise();
    }

    async getBrand(): Promise<GenericResponse<Array<BrandViewModelMultiSelector>>> {
        return this.dataProvider.GetAll<GenericResponse<Array<BrandViewModelMultiSelector>>>(Urls.GetBrands).toPromise();
    }

    AddEditMechanicCompetence(mechanicCompetence: any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditMechanicCompetence, mechanicCompetence).toPromise();
    }

    GetMechanicCompetenceByMechanicId(Id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicCompetenceByMechanicId, Id).toPromise();
    }
    async getBrandsByCompetence(competenceid: number): Promise<GenericResponse<Array<BrandViewModelMultiSelector>>> {
        return this.dataProvider.Get<GenericResponse<Array<BrandViewModelMultiSelector>>>(Urls.GetBrandsByCompetence, competenceid).toPromise();
    }

    async getMechanicEfficiencyReport(mechanicEfficiencyRequestModel: MechanicEfficiencyReportRequestModel): Promise<GenericResponse<MechanicEfficiencyReportResponseModel>> {
        return this.dataProvider.Post<GenericResponse<MechanicEfficiencyReportResponseModel>>(Urls.GetMechanicEfficiencyReport, mechanicEfficiencyRequestModel).toPromise();
    }
    async GetMechanicReport(DealerId: string): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicReport, DealerId).toPromise();
    }
    async GetServiceMechanicWiseByDealer(DealerId: string,language: string): Promise<any> {        
            return this.dataProvider.Get<any>(Urls.GetServiceMechanicWiseReport, DealerId,language).toPromise();          
    }
    async getMechanicAccracyReport(mechanicAccracyRequestModel: MechanicAccuracyReportRequestModel): Promise<GenericResponse<MechanicAccuracyResponseModel>> {
        return this.dataProvider.Post<GenericResponse<MechanicAccuracyResponseModel>>(Urls.GetMechanicAccuracyReport, mechanicAccracyRequestModel).toPromise();
    }
    async GetTimeStampReport(requestBody: any): Promise<GenericResponse<Array<TimeStampResponseModel>>> {
        return this.dataProvider.Post<GenericResponse<Array<TimeStampResponseModel>>>(Urls.GetTimeStampReport, requestBody).toPromise();
    }
    async getTotalSoldHoursReport(requestBody: any): Promise<GenericResponse<TotalSoldHoursReportResponseModel>> {
        return this.dataProvider.Post<GenericResponse<TotalSoldHoursReportResponseModel>>(Urls.GetTotalSoldHoursReport, requestBody).toPromise();
    }
    async GetTimeStampDetails(requestBody: any): Promise<GenericResponse<Array<TimeStampResponseModel>>> {
        return this.dataProvider.Post<GenericResponse<Array<TimeStampResponseModel>>>(Urls.GetTimeStampDetails, requestBody).toPromise();
    }
    async ResyncMechanic(mechanicId: number): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Get<GenericResponse<boolean>>(Urls.ResyncMechanic, mechanicId).toPromise();
    }
    async GetMechanicWorkTimeStampList(requestBody: any): Promise<GenericResponse<Array<MechanicTimeStampReportModel>>> {
        return this.dataProvider.Post<GenericResponse<Array<MechanicTimeStampReportModel>>>(Urls.GetMechanicWorkTimeStampList, requestBody).toPromise();
    }
    async GetMechanicLeaveTypes(): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicLeaveTypes).toPromise();
    }
}